import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const [toastMsg, setToastMsg] = useState("");
  const column1 = categories.slice(0, 7);
  const column2 = categories.slice(7, 14);

  const showToast = (msg: string) => {
    setToastMsg(msg);
    setTimeout(() => setToastMsg(""), 3000);
  };

  return (
    <footer className="bg-secondary-900 text-background-50">
      {toastMsg && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-foreground-950 text-background-50 px-6 py-3 rounded-full text-sm font-medium animate-fade-in-up shadow-sm">
          {toastMsg}
        </div>
      )}

      <div className="w-full px-6 md:px-10 py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <Link
              to="/"
              className="text-2xl font-heading font-bold text-background-50 tracking-tight inline-block cursor-pointer"
            >
              itaobuy<span className="text-secondary-400">.</span>cam
            </Link>
            <p className="mt-4 text-secondary-300 text-sm leading-relaxed max-w-sm">
              Your trusted gateway to curated China shopping spreadsheets. Compare agents, discover products, and shop smarter from Taobao, 1688, and Weidian.
            </p>
            <div className="mt-6">
              <p className="text-sm text-secondary-400 mb-3">Stay updated with the latest spreadsheet releases</p>
              <form
                id="newsletter-form"
                data-readdy-form
                className="flex gap-2"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.target as HTMLFormElement;
                  const emailInput = form.querySelector('input[name="email"]') as HTMLInputElement;
                  const honeypot = form.querySelector('input[name="website_alt"]') as HTMLInputElement;
                  if (honeypot && honeypot.value.trim() !== "") return;
                  try {
                    const formData = new URLSearchParams();
                    formData.append("email", emailInput.value);
                    const response = await fetch("https://readdy.ai/api/form/d8vtqtc6ci2plld1o9d0", {
                      method: "POST",
                      headers: { "Content-Type": "application/x-www-form-urlencoded" },
                      body: formData.toString(),
                    });
                    if (response.ok) {
                      emailInput.value = "";
                      showToast("Subscribed successfully!");
                    } else {
                      showToast("Something went wrong. Please try again.");
                    }
                  } catch {
                    showToast("Something went wrong. Please try again.");
                  }
                }}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  className="flex-1 bg-secondary-800 border border-secondary-700 rounded-lg px-4 py-2.5 text-sm text-background-50 placeholder:text-secondary-500 outline-none focus:border-secondary-400 transition-colors"
                  required
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="bg-secondary-500 hover:bg-secondary-400 text-background-50 px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-send-line"></i>
                </button>
              </form>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Categories</h4>
              <div className="flex flex-col gap-2">
                {column1.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">More Categories</h4>
              <div className="flex flex-col gap-2">
                {column2.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2">
                <Link
                  to="/"
                  className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Home
                </Link>
                <Link
                  to="/shopping-guide"
                  className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Shopping Guide
                </Link>
                <Link
                  to="/itaobuyspreadsheet-guide"
                  className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Complete Guide
                </Link>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  itaobuy Sheet
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Buy It Now
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} itaobuy.cam — All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              itaobuyspreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              china shopping spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              taobao agent spreadsheet 2026
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}